export const debounceIntervals = {
    panel: {
        onlineUserFlagInterval: 10000 // 10s
    }
}